import { Modal } from 'Common/Supplyvue-ui'
import { DataQualityCheckPageProps } from './DataQuality.types'
import { Box } from '@mui/material'
import { DataQualityColumnSelectionMUITable } from './DataQualityColumnSelection.MuiTable'

export const DataQualityCheckModal = ({
  isModalOpen,
  handleModalClose,
  data,
  isDataLoading,
  column,
}: DataQualityCheckPageProps) => {
  const columnsCount = data[0] ? Object.keys(data[0]).length : 0

  return (
    <Modal
      header={`Data quality(${column})`}
      onClose={handleModalClose}
      open={isModalOpen}
      handleClose={handleModalClose}
      body={
        <Box
          minWidth={700}
          width={columnsCount * 100}
          maxWidth={1500}
          height={500}
        >
          <Box height={450}>
            <DataQualityColumnSelectionMUITable
              data={data}
              isLoading={isDataLoading}
              column={column}
            />
          </Box>
        </Box>
      }
    />
  )
}
